import { type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { type RouteSheetProps } from './props';
import { RouteSheetLight } from './route-sheet.light';
import { RouteSheetWoo } from './route-sheet.woo';
import { RouteSheetWooDark } from './route-sheet.woo-dark';

export function RouteSheet(props: Readonly<RouteSheetProps>) {
  return templates.getSkinSelector(skinSelector(props));
}

function skinSelector(props: RouteSheetProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <RouteSheetWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <RouteSheetWoo {...props} />,
      },
    ],
    defaultValue: <RouteSheetLight {...props} />,
  };
}
